import { v4 as uuid } from 'uuid';
import { FLIGHT_NETWORK_NAME } from "consts/common";
import { flow, toGenerator, types } from "mobx-state-tree";
import { PointModel } from "models/FlightNetwork/MapEntity";
import { OperationFailure, OperationInProgress, OperationNotStarted, OperationStatusModel, OperationSuccess } from "models/common/OperationStatus";
import oversight from "services/oversight";
import { FlightNetworkStatus } from "services/oversight/types";

const FlightNetworkStore = types.model('FlightNetworkStore', {
  name: types.maybeNull(types.string),
  version: types.maybeNull(types.number),
  center_point: types.maybeNull(PointModel),
  fetchStatus: types.optional(OperationStatusModel, () => OperationNotStarted()),
})
.views(self => ({
  get isLoading() {
    return self.fetchStatus.inProgress
  }
}))
.actions(self => ({
  fetchFlightNetworkIfNeeded: flow(function* () {
    if (!self.fetchStatus.isNotStarted) {
      return
    }

    self.fetchStatus = OperationInProgress()
    const response = yield* toGenerator(oversight.getFlightNetwork(FLIGHT_NETWORK_NAME, FlightNetworkStatus.ready))

    if (response.error) {
      self.fetchStatus = OperationFailure(response.error)
      return
    }

    self.fetchStatus = OperationSuccess()

    self.name = response.result.name
    self.version = response.result.version

    if (response.result.center_point) {
      self.center_point = PointModel.create({
        ...response.result.center_point,
        uuid: uuid(),
      })
    }
  }),
  resetFlightNetwork: function() {
    self.name = null
    self.version = null
    self.center_point = null
    self.fetchStatus = OperationNotStarted()
  }
}))

export default FlightNetworkStore